import { DashboardData } from "../types/dashboardType";
import { ApiResponse } from "../types/responseType";
import customFetch from "../util/config/axiosConfig";
import { toast } from "sonner";

const dashboardApis = {
  // Fetch Dashboard Data by branch
  fetchDashboardData: async (
    branchCode: string,
    params?: { classId?: number; staffId?: number },
  ): Promise<DashboardData | undefined> => {
    try {
      const response = await customFetch.get<ApiResponse<DashboardData>>(
        `/api/v1/dashboard/data/${branchCode}`,
        { params },
      );

      if (response.data.status === 1) {
        return response.data.data;
      } else {
        // toast.error("Failed to fetch dashboard data");
        return undefined;
      }
    } catch (error: any) {
      console.error("Error fetching dashboard data:", error);
      toast.error(error.message || "Something went wrong");
    }
  },
};

export default dashboardApis;
